export const isProcessing = (status: string | undefined) =>
  Boolean(status?.toLowerCase()?.endsWith("processing"));

export const isReported = (status: string | undefined) =>
  Boolean(status?.toLowerCase()?.endsWith("reported"));

export const isOversized = (status: string | undefined) =>
  Boolean(status?.toLowerCase()?.endsWith("oversized"));

export const isInvalidReport = (status: string | undefined) =>
  Boolean(status?.toLowerCase()?.endsWith("invalid report"));

export const determineStatus = (status: string | undefined) => {
  const [, reason] = status?.split(":") || [];
  return reason ?? status;
};
